// AI Speaking Engine — admin tarafı çağrıları.
// DlaVia AIController üzerinden HTTPS proxy edilir.

import axios from "axios";
import { AI_BASE, AI_API_KEY, AI_ADMIN_TOKEN, ODATA_BASE } from "../config";

const _client = axios.create({
    baseURL: AI_BASE,
    timeout: 60000,
});

function _authHeaders(includeAdmin = false) {
    const h = { "X-API-Key": AI_API_KEY };
    if (includeAdmin) h["X-Admin-Token"] = AI_ADMIN_TOKEN;
    return h;
}

/**
 * Tarih aralığında AI tüketim özeti.
 * @param {string} from "YYYY-MM-DD"
 * @param {string} to   "YYYY-MM-DD"
 * @param {string|number} [userId] opsiyonel filtre
 */
export async function getAICostReport(from, to, userId) {
    const params = { from, to };
    if (userId) params.user_id = userId;
    const resp = await _client.get("/Cost", {
        params,
        headers: _authHeaders(true),
    });
    return resp.data;
}

/** Yüzeysel sağlık kontrolü — auth gerektirmez. */
export async function getAIHealth() {
    const resp = await _client.get("/Health");
    return resp.data;
}

/**
 * Anthropic + Deepgram + disk gerçek ping.
 * Pahalı — manuel buton/saatlik trigger ile çağır.
 */
export async function getAIHealthDeep() {
    const resp = await _client.get("/HealthDeep", {
        headers: _authHeaders(false),
        timeout: 30000,
    });
    return resp.data;
}

/**
 * OData Users — minimal alanlar (picker/lookup için).
 * Tek liste cache'lensin diye küçük tutuyoruz.
 */
let _usersCache = null;
export async function getAllUsersLookup() {
    if (_usersCache) return _usersCache;
    const resp = await axios.get(
        `${ODATA_BASE}/Users?$select=ID,Users_NameSurname,EMail&$orderby=ID desc&$top=2000`,
        { headers: { Accept: "application/json", "X-Admin-Token": AI_ADMIN_TOKEN }, timeout: 30000 }
    );
    _usersCache = (resp.data?.value || []).map(u => ({
        id:    u.ID,
        name:  u.Users_NameSurname || u.EMail || `#${u.ID}`,
        email: u.EMail || "",
    }));
    return _usersCache;
}
export function clearUsersCache() { _usersCache = null; }

// ── Dashboard (server-side aggregated, fast) ──
export async function getDashboardStats() {
    const resp = await axios.get(`${ODATA_BASE}/api/Dashboard/Stats`, {
        headers: { Accept: "application/json" },
        timeout: 15000,
    });
    return resp.data;
}

export async function getDashboardDailyActivity(days = 30) {
    const resp = await axios.get(`${ODATA_BASE}/api/Dashboard/DailyActivity?days=${days}`, {
        headers: { Accept: "application/json" },
        timeout: 15000,
    });
    return resp.data;
}

export async function getDashboardScoreBands() {
    const resp = await axios.get(`${ODATA_BASE}/api/Dashboard/ScoreBands`, {
        headers: { Accept: "application/json" },
        timeout: 15000,
    });
    return resp.data;
}

export async function getDashboardQuestionTypeBreakdown() {
    const resp = await axios.get(`${ODATA_BASE}/api/Dashboard/QuestionTypeBreakdown`, {
        headers: { Accept: "application/json" },
        timeout: 15000,
    });
    return resp.data;
}
